module.exports = __webpack_public_path__ + "img/product-preview-80.ba65254.png";